/**
 * Cross-site cookie helpers for the Swayam widget.
 *
 * The widget runs as a cross-site iframe, so its token cookies need CHIPS
 * (`SameSite=None; Secure; Partitioned`) to be stored and read in a third-party context; plain-http
 * local dev falls back to `Lax`. These live in the Swayam scope on purpose — the main platform
 * app's first-party cookies must never receive these attributes.
 */
export const tokenCookieSecurity = (): string => {
  const isHttps = typeof window !== "undefined" && window.location.protocol === "https:"
  return isHttps ? "SameSite=None; Secure; Partitioned" : "SameSite=Lax"
}

/** Write a Swayam token cookie. Omit `maxAgeSeconds` for a session cookie (cleared on tab close). */
export const setAuthCookie = (name: string, value: string, maxAgeSeconds?: number): void => {
  const parts = [`${name}=${value}`, "path=/"]
  if (maxAgeSeconds !== undefined) parts.push(`max-age=${maxAgeSeconds}`)
  parts.push(tokenCookieSecurity())
  document.cookie = parts.join("; ")
}

/** Clear a Swayam token cookie. Mirrors {@link setAuthCookie} so a partitioned cookie is matched. */
export const clearAuthCookie = (name: string): void => {
  document.cookie = `${name}=; path=/; max-age=0; ${tokenCookieSecurity()}`
}
